const coSwiper1 = new Swiper('.co-culture-s3-slider-1', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 400,
  loop: true,
  centeredSlides: true,
  navigation: {
    nextEl: '.co-culture-s3 .swiper-button-next',
    prevEl: '.co-culture-s3 .swiper-button-prev',
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  watchSlidesProgress: true,
  // freeMode: {
  //   enabled: true, 
  //   sticky: true, 
  //   momentum: false, 
  // },
  mousewheel: {
    forceToAxis: true,
    // releaseOnEdges: true,
  }
});
const coSwiper2 = new Swiper('.co-culture-s3-slider-2', {
  slidesPerView: 1,
  speed: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
});
const coSwiper3 = new Swiper('.co-culture-s3-slider-3', {
  slidesPerView: 1,
  speed: 400,
  effect: 'fade',
  watchSlidesProgress: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  allowTouchMove: false,
});
coSwiper1.on('slideChange', () => {
  coSwiper2.slideToLoop(coSwiper1.realIndex);
  coSwiper3.slideToLoop(coSwiper1.realIndex);
});


